package gr.tech.site.pages.blog

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initGreenreabteswinsprestigiousPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("blog/greenreabteswinsprestigious.md", FrontMatterElement.Builder { addScalar("title", "Green Rebates Wins Prestigious 2024 Seal Sustainable Service Award"); addScalar("description", "We are thrilled to announce that Green Rebates has been honored with the 2024 Seal Sustainable Service Award! This recognition places us among an elite group of industry leaders dedicated to sustainability and environmental stewardship."); addScalar("author", "Ben Madden"); addScalar("date", "2024-07-1"); addScalar("updated", "2026-02-17"); addScalar("image", "/images/blog/greenrebateswinprestigious.png"); addList("tags") { addScalar("Big Incentives"); addScalar("Big Rebates"); addScalar("Cost Savings"); addScalar("Energy Efficiency Programs"); addScalar("Energy Incentives"); addScalar("Energy Rebates"); addScalar("Energy-efficient Upgrades"); addScalar("Financial Incentives for Horticulture"); addScalar("Green Rebates"); addScalar("Horticulture Energy Savings"); addScalar("Horticulture Sustainability"); addScalar("Rebates vs. Incentives"); }; }))
}

@Page("/blog/green-rebates-wins-prestigious-2024-seal-sustainable-service-award")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun GreenreabteswinsprestigiousPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("green-rebates-wins-prestigious-2024-seal-sustainable-service-award") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Green Rebates Wins Prestigious 2024 Seal Sustainable Service Award")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("celebrating-excellence-in-sustainability") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Celebrating Excellence in Sustainability")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We are thrilled to announce that ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://greenrebates.com/") {
            org.jetbrains.compose.web.dom.Text("Green Rebates")
        }
        org.jetbrains.compose.web.dom.Text(" has been honored with the 2024 Seal Sustainable Service Award! This recognition places us among an elite group of industry leaders dedicated to sustainability and environmental stewardship. The SEAL (Sustainability, Environmental Achievement & Leadership) Awards celebrate companies and individuals making a positive impact on the planet through innovative and impactful sustainable practices.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The 2024 SEAL Awards have recognized numerous notable companies, and we are proud to stand alongside them in this prestigious accolade. Other distinguished recipients in the 2024 Seal Awards Class include:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Gotham Greens")
            }
            org.jetbrains.compose.web.dom.Text(": Renowned for their innovative urban agriculture and sustainable farming practices.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Disneyland Resorts")
            }
            org.jetbrains.compose.web.dom.Text(": Celebrated for their comprehensive environmental initiatives and commitment to reducing their carbon footprint.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Lenovo")
            }
            org.jetbrains.compose.web.dom.Text(": Honored for their strides in creating environmentally friendly technology and reducing e-waste.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Microsoft")
            }
            org.jetbrains.compose.web.dom.Text(": Recognized for their ambitious sustainability goals and significant efforts in achieving carbon neutrality.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("PathWater")
            }
            org.jetbrains.compose.web.dom.Text(": Applauded for their mission to eliminate single-use plastics with their reusable, aluminum water bottles.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("a-commitment-to-sustainable-services") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("A Commitment to Sustainable Services")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At Green Rebates, sustainability is at the core of everything we do. Our mission is to provide eco-friendly solutions that help individuals and businesses reduce their environmental impact while saving money. Winning the 2024 Seal Sustainable Service Award is a testament to our dedication to creating a greener, more sustainable future.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We are incredibly honored to be in the company of such esteemed organizations, each making significant contributions to sustainability in their respective fields. This award not only validates our efforts but also motivates us to continue pushing the boundaries of what is possible in sustainable services.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("join-us-in-celebrating") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Join Us in Celebrating")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We invite you to learn more about the SEAL Awards and the other remarkable recipients of the 2024 Seal Awards Class. Discover the innovative and impactful ways these companies are driving sustainability forward and how they are making a difference in our world.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://sealawards.com/sustainability-award-2024/") {
            org.jetbrains.compose.web.dom.Text("View the full list of 2024 Seal Award recipients here")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Thank you for supporting Green Rebates in our journey toward a more sustainable future. Together, we can make a lasting impact on our planet.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("about-green-rebates") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("About Green Rebates")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Industry-Specific Expertise")
            }
            org.jetbrains.compose.web.dom.Text(": We are the only rebate and incentive management company primarily serving the horticulture industry.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Knowledgeable Team")
            }
            org.jetbrains.compose.web.dom.Text(": Our expert team possesses extensive knowledge in light fixtures, HVAC systems, and dehumidifiers.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Proven Impact")
            }
            org.jetbrains.compose.web.dom.Text(": To date, we have secured over ${'$'}50 million in rebates and saved more than 350 million kilowatt-hours.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At Green Rebates, we are committed to providing sustainable solutions that benefit both the environment and your business. Our specialized services focus on helping horticulture operations implement eco-friendly practices through rebates, incentives, and expert guidance. For more information on how we can help you go green, visit our website at ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://greenrebates.com/") {
            org.jetbrains.compose.web.dom.Text("https://greenrebates.com")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Related:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/article/how-energy-incentives-and-green-rebates-are-leading-the-way-in-paving-the-way-for-sustainability-in-the-indoor-ag-space") {
                org.jetbrains.compose.web.dom.Text("How Energy Incentives and Green Rebates are Leading the Way in Paving the Way for Sustainability in the Indoor Ag Space")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/article/why-you-should-use-a-rebate-company-for-your-horticulture-energy-rebates-and-incentives") {
                org.jetbrains.compose.web.dom.Text("Why You Should Use A Rebate Company for Your Horticulture Energy Rebates and Incentives")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/blog/green-rebates-cannabis-business-times-2026-best-cannabis-companies-to-work") {
                org.jetbrains.compose.web.dom.Text("We Made The List! | Cannabis Business Times 2026 Best Cannabis Companies To Work")
            }
        }
    }
}
